<template>
  <SfAccordionItem
    :key="`accordion-${title}-${index}`"
    :model-value="opened[index]"
    class="border-t border-neutral-100 py-3 first-of-type:border-t-0"
    @keydown.enter="opened[index] = !opened[index]"
    @keydown.space="opened[index] = !opened[index]"
  >
    <template #summary>
      <div
        :id="$t(title)"
        class="flex items-center gap-5"
        :class="{ 'justify-between': fullWidth }"
        @click="opened[index] = !opened[index]"
      >
        <div>
          {{ $t(title) }}
          <slot name="title" />
          <template v-if="!opened[index]">
            <slot name="subTitle" />
          </template>
        </div>
        <SfIconChevronRight
          class="min-w-6 text-neutral-900"
          :class="{ '-rotate-90': opened[index], 'rotate-90': !opened[index] }"
        />
      </div>
    </template>
    <slot />
  </SfAccordionItem>
</template>

<script lang="ts" setup>
import { SfAccordionItem, SfIconChevronRight } from '@storefront-ui/vue';

interface Props {
  index: number;
  title?: string;
  subTitle?: string;
  open?: boolean;
  fullWidth?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  index: 0,
  title: '',
  open: false,
  fullWidth: true,
});

const initialValue = [];
initialValue[props.index] = props.open;

const opened = ref<boolean[]>(initialValue);
</script>
